export const defective = {
  title: 'Inventory(NG Items)',
}
